import {
  Component,
  ComponentRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalComponent implements OnInit, OnDestroy {
  private readonly destroy$: Subject<null> = new Subject<null>();

  @Input() maximizeBtn: boolean = false;
  @Input() minimizeBtn: boolean = false;
  hideHeader: boolean = false;
  displayCenter: string = '';

  @ViewChild('target', { read: ViewContainerRef, static: true }) vcRef!: ViewContainerRef;
  componentRef!: ComponentRef<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalComponent>,
    public readonly baseService: BaseService,
  ) {
    this.hideHeader = data.hideHeader;
    if (data.displayCenter) this.displayCenter = data.displayCenter;
  }

  ngOnInit() {
    this.componentRef = this.vcRef.createComponent(this.data.component);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  closeModal() {
    this.dialogRef.close(false);
  }
}
